import axios from "axios";
// default
axios.defaults.baseURL = process.env.REACT_APP_API_NEW_URL;
// content type
axios.defaults.headers.post["Content-Type"] = "application/json";
// intercepting to capture errors
axios.interceptors.response.use(
  function (response) {
    return response.data ? response.data : response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    const status = error?.response?.status ?? error?.status;
    let message;
    switch (status) {
      case 500:
        message = "Internal Server Error";
        break;
      case 401:
        message = "Invalid credentials";
        break;
      case 404:
        message = "Sorry! the data you are looking for could not be found";
        break;
      default:
        message = error?.response?.data?.message || error?.message || String(error);
    }
    // Session expired mid-use: broadcast so App can log out + return to login.
    // (Handled centrally — this module can't import the user store without a cycle.)
    if (status === 401) {
      try {
        window.dispatchEvent(new CustomEvent("auth:unauthorized"));
      } catch {
        /* non-browser env */
      }
    }
    // Reject with the REAL error (not a bare string) so callers can branch on
    // err.response?.status and read err.message; the friendly text goes on both.
    if (error instanceof Error) {
      (error as any).userMessage = message;
      error.message = typeof message === "string" ? message : error.message;
      return Promise.reject(error);
    }
    return Promise.reject(
      Object.assign(new Error(String(message)), {
        response: error?.response,
        status,
        userMessage: message,
      })
    );
  }
);
/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token) => {
  if (token) {
    axios.defaults.headers.common["x-access-token"] = token;
  } else {
    delete axios.defaults.headers.common["x-access-token"];
  }
};

// Seed the auth header from the persisted session at module load so EVERY
// request (legacy v1 backend_helper calls included) carries the token, even on
// a hard refresh before login() runs again. The login flow refreshes it.
try {
  const persisted =
    typeof localStorage !== "undefined" && localStorage.getItem("__accessToken");
  if (persisted) setAuthorization(persisted);
} catch {
  /* localStorage unavailable (SSR/sandbox) — ignore */
}

class APIClient {
  /**
   * Fetches data from given url
   */

  //  get = (url, params) => {
  //   return axios.get(url, params);
  // };
   get = (url: string, params: Record<string, any> | null = null) => {
    let response;

    if (params) {
      const queryString = new URLSearchParams(params).toString();
      response = axios.get(`${url}?${queryString}`);
    } else {
      response = axios.get(url);
    }

    return response;
  };
  /**
   * post given data to url
   */
  create = (url, data) => {
    return axios.post(url, data);
  };

  /**
   * post given data to url
   */
  postFormData = (url, formData) => {
    return axios.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  };
// Add this method if it doesn't exist in your API client
postJson = (url, data) => {
  return axios.post(url, data, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

  /**
   * Updates data
   */
  update = (url, data) => {
    return axios.put(url, data);
  };
  /**
   * Delete
   */
  delete = (url, config: any = null) => {
    if (config) {
      return axios.delete(url, config);
    } else {
      return axios.delete(url);
    }
  };
}
const getLoggedinUser = () => {
  const user = localStorage.getItem("authUser");
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

export { APIClient, setAuthorization, getLoggedinUser };